import type { AuthEvent } from "@/types/authLog";

/** PT-BR label for an auth event type (falls back to the raw code). */
export const AUTH_EVENT_LABEL: Record<AuthEvent, string> = {
  login_success: "Login",
  login_failed: "Login falhou",
  logout: "Logout",
  mfa_challenge: "Desafio MFA",
  mfa_success: "MFA verificado",
  mfa_failed: "MFA falhou",
  account_locked: "Conta bloqueada",
  refresh_reused: "Sessão reutilizada",
  password_reset_requested: "Reset de senha solicitado",
  password_reset_completed: "Senha redefinida",
};

export function authEventLabel(event: string): string {
  return AUTH_EVENT_LABEL[event as AuthEvent] ?? event;
}

/** Format an ISO timestamp as dd/mm/yyyy hh:mm (pt-BR). */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? "—"
    : d.toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
}
